import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { CategoryTag, LeadCategoryTag } from './CategoryTag';

type CategoryListProps = {
  items: string[];
  leadItem?: string;
};

const StyledContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(1),
}));

/**
 * CategoryList component from [MicroLibraryAppDetailsUI](https://dev.azure.com/orcha/MicroLibraryTemplate/_git/MicroLibraryAppDetailsUI)
 * @param {CategoryListProps} categoryListProps - The props for the CategoryList component
 * @returns {ReactElement} The CategoryList component
 */

export const CategoryList = ({ leadItem, items }: CategoryListProps) => {
  return (
    <StyledContainer>
      {leadItem && <LeadCategoryTag label={leadItem} />}
      {items?.map((label, index) => {
        // eslint-disable-next-line react/no-array-index-key
        return <CategoryTag key={`${label}-${index}`} label={label} />;
      })}
    </StyledContainer>
  );
};
